import React from 'react';
import { Supplier } from 'types/supplier';
import history from 'services/history';
import DataGridList from 'components/data-grid/DataGridList';
import { supplierTableTemplate } from '../../template/supplierTableTemplate';

type SupplierListTableProps = {
  suppliers: Supplier[];
};

const SupplierListTable: React.FC<SupplierListTableProps> = ({ suppliers }) => {
  return (
    <DataGridList
      template={supplierTableTemplate}
      rows={suppliers}
      getRowId={row => row.id}
      onRowClick={row => history.push(`/suppliers/${row.id}`)}
      fileName="fornecedores"
      sheetName="Fornecedores"
    />
  );
};

export default SupplierListTable;
